// Compact summary for the drill-down's Narrative Standards subsection: counts of the client's
// service-level / job-level standards (own + inherited, staged edits included, pending deletes
// excluded — the same list the modal shows) and the button that opens the manager modal.
// Bump `reloadToken` to refetch (e.g. after the modal closes).

import React from 'react';
import useNarrativeView from './useNarrativeView';
import './narratives.css';

export default function NarrativeStandardsSummary({ client, period, reloadToken, onConfigure, readOnly }) {
  const { view, error, initialLoading } = useNarrativeView({
    period, contIndex: client?.contIndex, reloadToken,
  });

  const rows = (view?.rows || []).filter(r => !r._pendingDelete);
  const serv = rows.filter(r => r.Level === 'SERV').length;
  const job = rows.filter(r => r.Level === 'JOB').length;
  const pending = (view?.rows || []).filter(r => r._pending).length;

  const row = (n, noun) => (
    <div className="nsx-sum-row">
      <span className="nsx-sum-count">{initialLoading || !view ? '—' : n}</span>
      <span className="nsx-sum-label">{noun}{n === 1 ? '' : 's'}</span>
    </div>
  );

  return (
    <div className="nsx-summary">
      <div className="nsx-sum-rows">
        {row(serv, 'service-level standard')}
        {row(job, 'job-level standard')}
        {pending > 0 && (
          <div className="nsx-sum-pending">
            <i className="fas fa-hourglass-half" /> {pending} pending approval
          </div>
        )}
        {error && !view && <div className="cs-field-error">Couldn't load: {error.message}</div>}
      </div>
      <button type="button" className="cs-btn cs-btn--add nsx-sum-btn" onClick={onConfigure}>
        <i className={`fas ${readOnly ? 'fa-eye' : 'fa-edit'}`} /> {readOnly ? 'View Narrative Standards' : 'Configure Narrative Standards'}
      </button>
    </div>
  );
}
